import GokuDataGrid from '@/components/GokuDataGrid'
import SubHeaders from '@/components/Headers/SubHeaders'
import { useModal } from '@/contexts/modal'
import useQueryClientCallback from '@/hooks/useQueryClientCallback'
import AddIcons from '@/icons/AddIcons'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import EditIcons from '@/icons/EditIcons'
import { DocumentModalProps } from '@/modals/DocumentModal'
import { IPermissionProps } from '@/types/shared'
import { isBeforeToday } from '@/utils/function'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { IAction } from 'vnetwork-ui/dist/components/GokuDataGrid/Actions'
import { deleteDocument, getDocument } from '../../services'
import { Documents } from '../../types/reponse'
import Filters from '../shared/Filters'
import { documentListColumn } from './column'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const ListDocuments: React.FC<IPermissionProps> = () => {
    const { t: translate } = useTranslation()
    const navigate = useNavigate()
    const { setModal } = useModal()
    const { refetch } = useQueryClientCallback({
        pattern: 'document-shared-with-me',
        mode: 'contains',
    })

    const handleSelectDocument = (row: Documents) => {
        setModal<DocumentModalProps>('DocumentModal/index', {
            title: row?.name_file,
            description: row?.descriptions,
            versions: row?.versions,
        })
    }
    const { mutateAsync: deleteDocumentMutation } = useMutationWithHandler(
        {
            mutationFn: (documentId: number) => deleteDocument(documentId),
        },
        {
            reactQueryKeys: QUERY_KEYS.DOCUMENTS,
            successMessage: translate('delete-success'),
            errorMessage: translate('delete-error'),
            onSuccess: () => {
                refetch()
            },
        }
    )

    const dataGridActions: IAction<Documents>[] = [
        {
            onClick: (row) => {
                navigate(
                    generatePathDatacentral(paths.documentUpdate, {
                        id: row?.document_id,
                    })
                )
            },
            title: translate('edit'),
            color: 'info',
            icon: <EditIcons />,
        },
        {
            onClick: async (row) => {
                await deleteDocumentMutation(row?.document_id)
            },
            title: translate('delete'),
            color: 'error',
            icon: <DeleteOutlineIcons />,
        },
    ]

    return (
        <>
            <SubHeaders
                actions={[
                    {
                        icon: <AddIcons />,
                        label: translate('create_document'),
                        variant: 'contained',
                        onClick: () => navigate(paths.documentCreate),
                    },
                ]}
                breadcrumbs={[
                    {
                        path: paths.documentCreate,
                        title: translate('document_list'),
                    },
                ]}
            />

            <div className="my-2">
                <GokuDataGrid
                    apiCall={getDocument}
                    reactQueryKey="document"
                    columns={documentListColumn(
                        translate,
                        handleSelectDocument
                    )}
                    actions={dataGridActions}
                    options={{
                        showSearch: true,
                        showHideColumn: true,
                        pageSize: 10,
                        title: '',
                    }}
                    searchPlaceholder="Search theo tên , mô tả..."
                    dataGridProps={{
                        getRowId: (row) => row?.document_id,
                        getRowClassName: (params) => {
                            if (
                                params.row.end_day &&
                                isBeforeToday(params.row.end_day)
                            ) {
                                return 'bg-red-200'
                            }
                            return ''
                        },
                    }}
                    filterDefaultValues={{
                        employee_id: [],
                        document_type: [],
                        document_level: [],
                        start_day: [],
                        end_day: [],
                    }}
                >
                    {({ control }) => {
                        return <Filters control={control} />
                    }}
                </GokuDataGrid>
            </div>
        </>
    )
}

export default ListDocuments
